import { Modal } from "@mui/material";
import { FC, ReactElement } from "react";
import './CustomModal.scss';

interface CustomModalProps {
    open: boolean;
    children: ReactElement;
    handleClose?: () => void;
}

export const CustomModal: FC<CustomModalProps> = ({ open, children, handleClose }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            className="modal-container"
        >
            {children}
        </Modal>
    )
}